import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Mail } from "lucide-react";
import { api } from "@/lib/api";
import BrandHeader from "@/components/BrandHeader";
import { TESTIDS } from "@/constants/testIds";
import { extractErrorMessage } from "@/lib/format";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      toast.error(extractErrorMessage(err, "No pudimos procesar la solicitud"));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-[#fafafa]" data-testid={TESTIDS.forgot.root}>
      <BrandHeader
        right={
          <Link to="/" className="btn-ghost">
            <ArrowLeft className="w-4 h-4" /> Volver
          </Link>
        }
      />
      <main className="max-w-md mx-auto px-6 md:px-10 pt-16 pb-24">
        <div className="card fade-in-up">
          <h1 className="font-display text-2xl font-bold text-gray-900">Recuperar contraseña</h1>
          {sent ? (
            <div className="mt-6 text-center">
              <div className="mx-auto w-14 h-14 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center mb-4">
                <Mail className="w-6 h-6" strokeWidth={1.75} />
              </div>
              <p className="text-gray-700">
                Si ese email existe en nuestro sistema, te hemos enviado un enlace para
                restablecer tu contraseña.
              </p>
              <p className="text-sm text-gray-500 mt-2">
                Revisa tu bandeja (y la carpeta de spam). El enlace expira en 1 hora.
              </p>
              <Link to="/" className="btn-primary mt-6 inline-flex">
                Volver al inicio
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <p className="text-sm text-gray-500">
                Introduce tu email y te enviaremos un enlace para restablecer tu contraseña.
              </p>
              <label className="block">
                <span className="text-xs font-medium text-gray-600 mb-1.5 block">Email</span>
                <input
                  type="email"
                  required
                  className="input-field"
                  placeholder="tuemail@empresa.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid={TESTIDS.forgot.emailInput}
                />
              </label>
              <button
                type="submit"
                disabled={loading}
                className="btn-primary w-full"
                data-testid={TESTIDS.forgot.submitBtn}
              >
                {loading ? "Enviando…" : "Enviar enlace"}
              </button>
            </form>
          )}
        </div>
      </main>
    </div>
  );
}
